import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import CalendarDay from './calendar-day';
import CalendarWeekSelectionGlow from './calendar-week-selection-glow';

import styles from './calendar.styles';

function CalendarWeek(props) {
  const { onSelectDate } = props;

  const weekData = buildWeekData(props);
  const selectionData = weekData.map(dayData => dayData.inCurrentMonth && dayData.selected);

  return (<div className="calendar-week">
    {weekData.map((dayData, index) => <CalendarDay
      {...dayData}
      key={index}
      onSelectDate={onSelectDate}
    />)}
    <CalendarWeekSelectionGlow selectionData={selectionData} />
  </div>);
}

CalendarWeek.propTypes = {
  start: PropTypes.instanceOf(Date),
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date).isRequired,
  month: PropTypes.number,
  highlightDays: PropTypes.instanceOf(Set),
  onSelectDate: CalendarDay.propTypes.onSelectDate,
};

export default pure(CalendarWeek);

function buildWeekData(props) {
  const { start, highlightDays, fromDate, toDate, minDate, maxDate, month } = props;

  const data = [];
  let day = new Date(start);

  for (let i = 0; i < 7; i++) {
    data.push({
      day,
      disabled: day < minDate || day > maxDate,
      inCurrentMonth: day.getMonth() === month,
      selected: isSelected(day, fromDate, toDate),
      highlighted: highlightDays.has(day.valueOf()),
    });

    day = new Date(Date.UTC(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate() + 1));
  }

  return data;
}

function isSelected(day, fromDate, toDate) {
  if (!fromDate) {
    return false;
  }
  return day.valueOf() === fromDate.valueOf()
    || (day > fromDate && day <= toDate);
}
